import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LogoBlog from "../../assets/logo.png";

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    cell: '',
    password: '',
    confirmPassword: '',
    role: 'user',
    status: 'active',
    action: 'user_registration'
  });
  
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.firstName || !formData.lastName || 
        !formData.email || !formData.password || !formData.confirmPassword) {
      toast.error('Please fill in all required fields');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    if (formData.cell.length !== 7) {
      toast.error('Please enter your last 7 digits of your cellphone number.');
      return;
    }

    setIsLoading(true);
    
    try {
      
      const response = await axios.post(
        'https://mindsinaction.com.na/api/mindsbackend/proccess.php',
        formData,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        }
      );

      if (response.data) {
        if (response.data.success) {
          toast.success(response.data.message || 'Registration successful!');
        } else {
          toast.error(response.data.message || 'Registration failed. Please try again.');
        }
      } else {
        toast.error('No response data received from server');
      }
      
    } catch (err) {
      console.error('Registration error:', err);
      
      if (err.response) {
        toast.error(err.response.data?.message || `Server error: ${err.response.status}`);
      } else if (err.request) {
        toast.error('No response from server. Please check your connection.');
      } else {
        toast.error(err.message || 'An unexpected error occurred');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='flex-column-center w-100' style={{ height: "100vh" }}>
      <div className="login-container pt-4">
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        
        <div className="login-box bg-white m-top-4">
          <div className='flex-raw-center w-100 mb-4 pb-4'>
            <div className='small-img'>
              <img className='image' src={LogoBlog} alt='Company Logo'/>
            </div>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className='flex-raw-center gap-1'>
                <div className="form-group">
                <label htmlFor="firstName">First Name*</label>
                <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter your first name"
                    disabled={isLoading}
                    required
                />
                </div>
                
                <div className="form-group">
                <label htmlFor="lastName">Last Name*</label>
                <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter your last name"
                    disabled={isLoading}
                    required
                />
                </div>
            </div>
            <div className='w-100 flex-raw-center gap-1'>
              <div className="form-group w-100">
                <label htmlFor="email">Cell* <span>enter 7 numbers only</span></label>
                <input
                  type="number"
                  id="cell"
                  name="cell"
                  value={formData.cell}
                  onChange={handleChange}
                  placeholder="Enter cell number e.g 4272721"
                  disabled={isLoading}
                  required
                />
              </div>
            </div>
            <div className='w-100 flex-raw-center gap-1'>
              <div className="form-group w-100">
                <label htmlFor="email">Email*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  disabled={isLoading}
                  required
                />
              </div>
            </div>
            <div className='flex-raw-center gap-1'>
              <div className="form-group">
                <label htmlFor="password">Password*</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Create a password (min 6 characters)"
                  disabled={isLoading}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password*</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm your password"
                  disabled={isLoading}
                  required
                />
              </div>
            </div>
            {/* Hidden fields for role and status with default values */}
            <input type="hidden" name="role" value="user" />
            <input type="hidden" name="status" value="active" />
            
            <button 
              type="submit" 
              className="login-button"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner"></span> Registering...
                </>
              ) : 'Register'}
            </button>
          </form>
          
          <div className="signup-link mt-3">
            Already have an account? <a href="/">Login</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;